import { environment } from '../../../../environments/environment';

export const role_urls = {
  get_roles: environment.apiUrl + 'ott/v1/get_roles',
  create_role: environment.apiUrl + 'role/v1/create_role',
  update_role: environment.apiUrl + 'role/v1/update_role',
  get_role_fields: environment.apiUrl + 'ott/v1/get_role_fields',
  role_heirarchy: environment.apiUrl + 'role/v1/role_heirarchy',
  user_role: environment.apiUrl + 'user/v1/get_user_role',
  update_user_role: environment.apiUrl + 'user/v1/update_user_role',
  get_role_parents: environment.apiUrl + 'ott/v1/get_role_parents',
  get_category_registration_settings:
    environment.apiUrl + 'register/v1/get_category_registration_settings',
  eligible_roles_registration:
    environment.apiUrl + 'ott/v1/get_eligible_roles_for_feature',
  get_children_hierarchy: environment.apiUrl + 'ott/v1/get_children_hierarchy',
  get_dashboard_data: environment.apiUrl + 'user/v1/get_dashboard_data',
};

export const request_urls = {
  list_user_role_requests:
    environment.apiUrl + 'user/v1/list_user_role_requests',
  get_user_role_requests_count:
    environment.apiUrl + 'user/v1/get_user_role_requests_count',
  get_user_role_requests: environment.apiUrl + 'user/v1/get_user_role_requests',
  get_user_role_children_count:
    environment.apiUrl + 'user/v1/get_user_role_children_count',
  get_children_hierarchy: environment.apiUrl + 'ott/v1/get_children_hierarchy',
  create_user_role: environment.apiUrl + 'user/v1/create_user_role',
};
export const file_upload_urls = {
  user_profile_url: environment.apiUrl + 'file_upload?path=UserProfile',
  user_profile_upload: environment.apiUrl + 'user/v1/user_profile_pic',
  get_user_profile_pic: environment.apiUrl + 'user/v1/get_user_profile_pic',
};
export const auth_urls = {
  login: environment.apiUrl + 'auth/v1/login',
  send_otp: environment.apiUrl + 'auth/v1/send_otp',
  verify_otp: environment.apiUrl + 'auth/v1/verify_otp',
  password_reset: environment.apiUrl + 'auth/v1/password_reset',
  signup_verification: environment.apiUrl + 'auth/v1/signup/send_otp',
  change_password: environment.apiUrl + 'user/v1/change_password',
  verify_email_change: environment.apiUrl + 'user/v1/verify_email_change',
  exchange_web_handoff_code:
    environment.apiUrl + 'auth/v1/exchange_web_handoff_code',
  create_web_handoff_code:
    environment.apiUrl + 'auth/v1/create_web_handoff_code',
};

export const fixture_urls = {
  create_stage: environment.apiUrl + 'stage/v1/create_stage',
  get_stages: environment.apiUrl + 'ott/v1/get_stages',
  update_stage: environment.apiUrl + 'stage/v1/update_stage',
  get_stage_participants:
    environment.apiUrl + 'stage/v1/get_stage_participants',
  upsert_stage_participants:
    environment.apiUrl + 'stage/v1/upsert_stage_participants',
  get_groups_metadata: environment.apiUrl + '/group/get_groups_metadata',
  delete_groups_metadata: environment.apiUrl + '/group/delete_groups_metadata',
  create_groups_metadata: environment.apiUrl + 'group/create_groups_metadata',
  update_groups_metadata: environment.apiUrl + 'group/update_groups_metadata',
  add_elite_players: environment.apiUrl + 'register/v1/manage_elite_players',
  add_excluded_players:
    environment.apiUrl + 'register/v1/manage_excluded_players',
  get_stage_configuration: environment.apiUrl + 'ott/v1/get_stages',
  set_stage_configuration:
    environment.apiUrl + 'stage/v1/set_stage_configuration',
  generate_fixtures: environment.apiUrl + 'fixture/v1/generate_fixtures',
  delete_fixtures: environment.apiUrl + 'fixture/v1/delete_fixtures',
  get_groups: environment.apiUrl + 'ott/v1/get_groups',
  create_group: environment.apiUrl + 'group/v1/create_group',
  update_group: environment.apiUrl + 'group/v1/update_group',
  get_group_participants:
    environment.apiUrl + 'group/v1/get_group_participants',
  upsert_group_participants:
    environment.apiUrl + 'group/v1/upsert_group_participants',
  draft_group_fixture: environment.apiUrl + 'fixture/v1/draft_group_fixture',
  get_group_matches: environment.apiUrl + 'ott/v1/get_group_matches',
  get_round_matches: environment.apiUrl + 'ott/v1/get_group_matches',
  get_knockout_fixtures:
    environment.apiUrl + 'fixture/v1/get_knockout_fixtures',
  get_stage_meta: environment.apiUrl + 'ott/v1/get_stages',
  upsert_stage_participants_seeds:
    environment.apiUrl + 'fixture/v1/upsert_stage_participants_seeds',
  get_knockout_matches: environment.apiUrl + 'ott/v1/get_knockout_matches',
  draft_knockout_fixture:
    environment.apiUrl + 'fixture/v1/draft_knockout_fixture',
  reset_stage_seeding: environment.apiUrl + 'stage/v1/reset_stage_seeding',
  get_dummy_group_matches:
    environment.apiUrl + 'group/v1/get_dummy_group_matches',
  previous_stages_summary:
    environment.apiUrl + 'stage/v1/previous_stages_summary',
  dummy_participants_replaced:
    environment.apiUrl + 'fixture/v1/dummy_participants_replaced',
  get_team_playing_order_with_matches:
    environment.apiUrl + 'ott/v1/get_team_playing_order_with_matches',
};

export const common_urls = {
  get_participant_types_and_categories:
    environment.apiUrl + 'ott/v1/get_participant_types_and_categories',
  get_events: environment.apiUrl + 'ott/v1/get_events?published=true',
  get_live_scored_matches:
    environment.apiUrl + 'ott/v1/get_live_scored_matches',
  get_event_categories: environment.apiUrl + 'ott/v1/get_events_categories',
  get_upcoming_events: environment.apiUrl + 'ott/v1/matches',
  get_day_schedule: environment.apiUrl + 'ott/v1/get_day_schedule',
  get_stages: environment.apiUrl + 'ott/v1/get_stages',
  get_venues: environment.apiUrl + 'ott/v1/event_venues',
  get_event_venue_days: environment.apiUrl + 'ott/v1/get_event_venue_days',
  get_groups: environment.apiUrl + 'ott/v1/get_groups',
  get_rounds: environment.apiUrl + 'ott/v1/get_rounds',
  get_match_guuide: environment.apiUrl + 'ott/v1/match_guide',
  get_matches: environment.apiUrl + 'ott/v1/matches',
  get_videos: environment.apiUrl + 'ott/v1/get_video',

  global_settings: environment.apiUrl + 'accommodation_travel_settings/global',
  get_countries: environment.apiUrl + 'config/countries',
  get_broadcasts: environment.apiUrl + 'ott/v1/events',
  recalculate_leaderboard:
    environment.apiUrl + 'ott/v1/leadership-points/recalculate',
  get_event_category_leaderboard:
    environment.apiUrl + 'ott/v1/leaderboard-ranking',

  get_all_stage_Team_player:
    environment.apiUrl + 'ott/v1/leadership-points/leaderboard/',
  get_all_stage_Team:
    environment.apiUrl +
    'ott/v1/leadership-points/group-participants/by-event-category',
  get_event_participants:
    environment.apiUrl + 'register/v1/get_event_participants',
  get_rule_settings: environment.apiUrl + 'rule_setting/v1/get_rule_settings',
  get_events_documents_sponsors:
    environment.apiUrl + 'ott/v1/get_event_documents_sponsors',
  get_event_finance_settings:
    environment.apiUrl + 'event/v1/get_event_finance_settings',

  get_player_events: environment.apiUrl + 'tms/v1/player/events',
  get_player_info: environment.apiUrl + 'user/v1/player/info',
  get_performance_metrics:
    environment.apiUrl + 'tms/v1/player/performance-metrics',
  get_recent_matches: environment.apiUrl + 'tms/v1/player/recent-matches',
  get_top_finishes: environment.apiUrl + 'tms/v1/player/top-finish',
  get_player_stats: environment.apiUrl + 'dashboard/v1/player/stats',
  get_player_performance: environment.apiUrl + 'dashboard/v1/player/performance',
  get_player_head_to_head: environment.apiUrl + 'dashboard/v1/player/head-to-head',
  get_player_live: environment.apiUrl + 'dashboard/v1/player/live',
  get_player_activity: environment.apiUrl + 'dashboard/v1/player/activity',
  get_player_insights: environment.apiUrl + 'dashboard/v1/player/insights',
  get_player_league: environment.apiUrl + 'dashboard/v1/player/league',
  get_player_career: environment.apiUrl + 'dashboard/v1/player/career',
  get_player_videos: environment.apiUrl + 'dashboard/v1/player/videos',
  get_player_open_events: environment.apiUrl + 'dashboard/v1/player/open-events',
  get_player_graphs: environment.apiUrl + 'dashboard/v1/player/graphs',
  get_head_to_head: environment.apiUrl + 'tms/v1/player/head-to-head',
  get_sections: environment.apiUrl + 'ott/v1/get_sections',
};
export const registration_urls = {
  get_participant_types_and_categories:
    environment.apiUrl + 'ott/v1/get_participant_types_and_categories',
  create_team: environment.apiUrl + 'team/v1/create_team',
  get_teams: environment.apiUrl + 'ott/v1/get_teams',
  list_all_players: environment.apiUrl + 'ott/v1/list_all_players',
  add_participants_to_cart:
    environment.apiUrl + 'order/order/add_participants_to_cart',
  add_participants_to_cart_v2:
    environment.apiUrl + 'order/order/add_participants_to_cart_v2',
  register_event_participants:
    environment.apiUrl + 'register/v1/register_event_participants',
  register_event_participants_v2:
    environment.apiUrl + 'register/v1/register_event_participants_v2',
  get_orders: environment.apiUrl + 'ott/v1/get_orders',
  delete_items_in_cart:
    environment.apiUrl + 'order/order/delete_participant_from_cart',
  delete_items_in_cart_v2:
    environment.apiUrl + 'order/order/delete_participant_from_cart_v2',
  list_possible_teams_parents:
    environment.apiUrl + 'user/v1/list_possible_teams_parents',
  update_team: environment.apiUrl + 'team/v1/update_team',
  update_event_participant:
    environment.apiUrl + 'register/v1/update_event_participant',
  update_event_participant_status:
    environment.apiUrl + 'register/v1/update_event_participant_status',
  add_teams_to_category_and_create_order:
    environment.apiUrl + 'order/order/add_teams_to_category_and_create_order',
  get_events_participants: environment.apiUrl + 'ott/v1/get_event_participants',
  get_display_seeding_settings:
    environment.apiUrl + 'ott/v1/get_display_seeding_settings',
  get_player_eligible_categories:
    environment.apiUrl + 'event/v1/get_player_eligible_categories',
  create_self_dummy_team: environment.apiUrl + 'team/v1/create_self_dummy_team',
  get_single_registered_player:
    environment.apiUrl + 'register/v1/get_single_register_players',
  get_events_with_partner_requests:
    environment.apiUrl + 'register/v1/get_events_with_partner_requests',
  get_partner_requests: environment.apiUrl + 'register/v1/get_partner_requests',
  accept_pair_request_and_register:
    environment.apiUrl + 'register/v1/accept_pair_request_and_register',
  update_pair_request_status:
    environment.apiUrl + 'register/v1/update_pair_request_status',
  add_delegation_members:
    environment.apiUrl + 'register/v1/add_delegation_members',
  get_delegation_details:
    environment.apiUrl + 'ott/v1/get_delegation_details',
  get_partner_details: environment.apiUrl + 'register/v1/get_partner_details',
  withdraw_self_registered_player:
    environment.apiUrl + 'register/v1/withdraw_self_registered_player',
  withdraw_own_registration:
    environment.apiUrl + 'register/v1/withdraw_own_registration',
  cancel_partner_invitation:
    environment.apiUrl + 'register/v1/cancel_partner_invitation',
  create_partner_pair: environment.apiUrl + 'register/v1/create_partner_pair',
  venue_registration: environment.apiUrl + 'venue/v1/registration',
  venue_registration_confirm:
    environment.apiUrl + 'venue/v1/registration/confirm',
  venue_registration_cancel:
    environment.apiUrl + 'venue/v1/registration/cancel-request',
  venue_registration_prefill:
    environment.apiUrl + 'venue/v1/registration/prefill',
  venue_registration_list:
    environment.apiUrl + 'venue/v1/registration/list',
  venue_settings: environment.apiUrl + 'venue/v1/settings',
};
export const order_urls = {
  get_participant_orders:
    environment.apiUrl + 'ott/v1/get_participant_orders',
  get_user_registered_events:
    environment.apiUrl + 'register/v1/get_user_registered_events',
  get_membership_order_history: environment.apiUrl + 'ott/v1/get_membership_orders',
  get_user_registration_history:
    environment.apiUrl + 'register/v1/get_user_registration_history',
  get_order_payment_details:
    environment.apiUrl + 'orders/v1/get_order_payment_details',
};

export const umpire_settings_urls = {
  get_event_days: environment.apiUrl + 'ott/v1/get_event_venue_days',
  add_officials_to_cart:
    environment.apiUrl + 'order/order/add_official_to_cart',
  register_officials:
    environment.apiUrl + 'register/v1/register_event_officials',
  remove_officials:
    environment.apiUrl + 'order/order/remove_official_from_cart',
  get_event_officials: environment.apiUrl + 'register/v1/get_event_officials',
  update_event_officials:
    environment.apiUrl + 'register/v1/update_event_officials',
};

export const accomodation_urls = {
  get_accomm_travel_settings:
    environment.apiUrl + 'accommodation_travel_settings/accommodation',
  get_registered_players: environment.apiUrl + 'ott/v1/bookings/',
  get_other_roles: environment.apiUrl + 'accommodation/bookings/',
  list_all_users: environment.apiUrl + 'user/v1/list_all_users',
  list_all_users_accomodation:
    environment.apiUrl + 'user/v1/list_all_users_accommodation',

  create_temp_member: environment.apiUrl + 'temporary_members/',
  add_other_roles:
    environment.apiUrl + 'accommodation/bookings/add_other_roles',
  available_hotel_rooms:
    environment.apiUrl +
    'accommodation/events/{event_id}/available_hotels_rooms',
  get_edit_available_hotels:
    environment.apiUrl +
    'accommodation/events/{event_id}/edit_available_hotels_rooms/{booking_id}',
  get_accom_analytics: environment.apiUrl + 'accommodation/events/',
  get_accom_cart: environment.apiUrl + 'accommodation/cart/',
  update_accom_cart: environment.apiUrl + 'accommodation/cart/update',
  create_booking: environment.apiUrl + 'accommodation/bookings/create_booking',
  create_accommodation_bookings:
    environment.apiUrl + 'accommodation/bookings/create_bookings',

  get_bookings_listing:
    environment.apiUrl + 'admin/accommodation/bookings_list',
  get_edit_cart:
    environment.apiUrl + 'accommodation/cart/edit/{accommodation_booking_id}',
  edit_update_cart: environment.apiUrl + 'accommodation/cart/edit/update',
  delete_user_role:
    environment.apiUrl + 'accommodation/bookings/delete_other_roles',
  delete_temp_member:
    environment.apiUrl + 'temporary_members/accommodation/{temp_member_id}',
  get_accommodation_version_history:
    environment.apiUrl +
    'accommodation/version/version-history/{accommodation_booking_id}',

  get_accommodation_version_changes:
    environment.apiUrl +
    'accommodation/version/version-changes/{accommodation_booking_id}/{version}',
  get_room_division:
    environment.apiUrl +
    'accommodation/version/room_division/{accommodation_booking_id}',
  get_booking_details_version:
    environment.apiUrl +
    'accommodation/version/booking_details_by_version/{accommodation_booking_id}',
  version_registered_players:
    environment.apiUrl +
    'accommodation/version/registered_players/{accommodation_booking_id}',

  accomodation_registered_players:
    environment.apiUrl +
    'accommodation/bookings/registered_players/{accommodation_booking_id}',
  get_registered_other_roles:
    environment.apiUrl +
    'accommodation/bookings/other_roles/{accommodation_booking_id}',

  update_booking:
    environment.apiUrl +
    'accommodation/bookings/update_booking/{accommodation_booking_id}',
  // accomodation_registered_players : environment.apiUrl + 'accommodation/bookings/registered_players/{accommodation_booking_id}',
  // get_registered_other_roles : environment.apiUrl + 'accommodation/bookings/other_roles/{accommodation_booking_id}',
  get_accommodation_total_person:
    environment.apiUrl + 'accommodation/bookings/{booking_id}/booking_details',
  // update_booking : environment.apiUrl + 'accommodation/bookings/update_booking/{accommodation_booking_id}',
  update_edit_accom_cart: environment.apiUrl + 'accommodation/cart/edit/update',

  get_all_filtered_hotels:
    environment.apiUrl + 'accommodation/filter/get_all_hotels',
  get_all_filtered_rooms:
    environment.apiUrl + 'accommodation/filter/{hotel_id}/get_all_rooms',
  save_draft_participants:
    environment.apiUrl + 'accommodation/draft/save_selected_participants',
  update_selected_participants:
    environment.apiUrl + 'accommodation/draft/update_selected_participants',
  get_accommodation_poc_details:
    environment.apiUrl +
    'accommodation/poc/{event_id}/get_details/{user_role_id}',
  create_accommodation_poc_details:
    environment.apiUrl +
    'accommodation/poc/{event_id}/create_details/{user_role_id}',
  update_accommodation_poc_details:
    environment.apiUrl +
    'accommodation/poc/{event_id}/update_details/{user_role_id}',
  available_hotels:
    environment.apiUrl + 'accommodation/available_hotels/{event_id}',
  occupancy_options:
    environment.apiUrl + 'accommodation/filter/occupancy_options',
  get_selected_participants_preferences:
    environment.apiUrl +
    'accommodation/draft/get_selected_participants_preferences',
  available_hotels_rooms:
    environment.apiUrl +
    'accommodation/bookings/{event_id}/available_hotels_rooms',
  edit_available_hotels_rooms:
    environment.apiUrl +
    'accommodation/bookings/edit/{event_id}/available_hotels_rooms',
  save_room_players_mapping:
    environment.apiUrl + 'accommodation/draft/save_room_players_mapping',
  individual_list: environment.apiUrl + 'ott/v1/accommodation/individual_list',
  restore_bookings: environment.apiUrl + 'accommodation/restore_bookings',
  withdraw_bookings: environment.apiUrl + 'accommodation/withdraw_bookings',
  get_registered_participants_for_edit:
    environment.apiUrl +
    'accommodation/bookings/edit/get_registered_participants',
  get_other_participants_for_edit:
    environment.apiUrl + 'accommodation/bookings/edit/get_other_participants',
  validate_preferences:
    environment.apiUrl + 'accommodation/bookings/edit/validate_preferences',
  update_bookings_edit:
    environment.apiUrl + 'accommodation/bookings/edit/update_bookings',
  update_bookings_edit_tms:
    environment.apiUrl + 'accommodation/bookings/edit/update_bookings_tms',
  delegation_player_details:
    environment.apiUrl + 'accommodation_delegation/delegation_player_details',
};

export const travel_urls = {
  get_registered_players: environment.apiUrl + 'ott/v1/travel/bookings/',
  get_other_roles: environment.apiUrl + 'ott/v1/travel/bookings/',
  add_other_roles: environment.apiUrl + 'travel/bookings/add_other_roles',
  get_travel_settings:
    environment.apiUrl + 'accommodation_travel_settings/travel',
  temporary_members_travel: environment.apiUrl + 'temporary_members/travel',
  delete_other_roles: environment.apiUrl + 'travel/bookings/delete_other_roles',
  travel_cart_update: environment.apiUrl + 'travel/cart/update',
  edit_travel_cart_update: environment.apiUrl + 'travel/cart/edit/update',
  get_travel_cart: environment.apiUrl + 'travel/cart',
  get_edit_travel_cart: environment.apiUrl + 'travel/cart/edit',
  create_bookings: environment.apiUrl + 'travel/bookings',
  create_bookings_update: environment.apiUrl + 'travel/bookings/update_booking',
  individual_list: environment.apiUrl + 'ott/v1/travel/individual_list',
  travel_bookings_registered_players:
    environment.apiUrl + 'travel/bookings/registered_players',
  travel_bookings_other_roles:
    environment.apiUrl + 'travel/bookings/other_roles',
  get_travel_booking_details: environment.apiUrl + 'travel/bookings',
  get_travel_booking_details_version:
    environment.apiUrl + 'travel/version/booking_details',
  get_travel_booking_details_version_list:
    environment.apiUrl + 'travel/version/version-history',
  get_travel_booking_details_version_changes:
    environment.apiUrl + 'travel/version/version-changes',
  get_travel_booking_details_version_registered_players:
    environment.apiUrl + 'travel/version/registered_players',
  travel_users_excel: environment.apiUrl + 'export/travel_users',
  get_list_all_users_travel:
    environment.apiUrl + 'ott/v1/list_all_users_travel',
  update_bookings_bulk: environment.apiUrl + 'travel/bookings/update_bookings',
  restore_bookings: environment.apiUrl + 'travel/restore_bookings',
  withdraw_bookings: environment.apiUrl + 'travel/withdraw_bookings',
};

export const schedular_urls = {
  get_matches: environment.apiUrl + 'ott/v1/matches',
  get_matches_auth: environment.apiUrl + 'match/v1/matches',
  get_matches_auth_custom: environment.apiUrl + 'match/v1/matches/custom',
  assign_match_slots: environment.apiUrl + 'planner/v1/assign_match_slots',
  reset_match_slots: environment.apiUrl + 'planner/v1/reset_match_slots',
  get_day_schedule: environment.apiUrl + 'ott/v1/get_day_schedule',
  remove_match_slots: environment.apiUrl + 'planner/v1/remove_match_slots',
  get_rounds: environment.apiUrl + 'ott/v1/get_rounds',
  assign_umpire: environment.apiUrl + 'planner/v1/assign_event_official_match',
  reset_umpire: environment.apiUrl + 'planner/v1/reset_event_official_match',
  remove_umpire: environment.apiUrl + 'planner/v1/remove_event_official_match',
  get_events_slots: environment.apiUrl + 'ott/v1/get_event_slots',
};

export const rating_urls = {
  bulk_component_summary:
    environment.apiUrl +
    'ott/v1/rankings/lists/participants/component-summary-by-event-stage/bulk',
  get_current_ranking: environment.apiUrl + 'rating/v1/player/current-ranking',
};

export const award_urls = {
  get_event_category_rewards: environment.apiUrl + 'ott/v1/get_rewards',
  get_event_standings: environment.apiUrl + 'ott/v1/get_event_participants',
  // List (no award_id) and detail (with award_id) share this OTT route.
  get_awards_standings: environment.apiUrl + 'ott/v1/awards/standings',
};

export const cms_urls = {
  get_cms_layouts: environment.apiUrl + 'cms/v1/get-section-layouts',
  get_cms_layout_detail: environment.apiUrl + 'cms/v1/get',
};

export const score_urls = {
  get_tie_players: environment.apiUrl + 'ott/v1/score/head-to-head-stats',
};

export const delegation_urls = {
  get_delegation_details:
    environment.apiUrl + 'ott/v1/get_delegation_details',
  create_delegation: environment.apiUrl + 'register/v1/create_delegation',
  update_delegation: environment.apiUrl + 'register/v1/update_delegation',
  add_delegation_members:
    environment.apiUrl + 'register/v1/add_delegation_members',
  update_delegation_members:
    environment.apiUrl + 'register/v1/update_delegation_members',
  update_delegation_member_details:
    environment.apiUrl + 'register/v1/update_delegation_member_details',
  switch_delegation_members:
    environment.apiUrl + 'register/v1/switch_delegation_users',
  get_delegation_roles:
    environment.apiUrl + 'register/v1/get_delegation_role_statistics',
};

export const membership_urls = {
  get_membership_plans: environment.apiUrl + 'ott/v1/get_plans',
  get_memberships: environment.apiUrl + 'membership/v1/get_memberships',
  get_membership_overview: environment.apiUrl + 'membership/v1/get_membership_overview',
  create_bulk_membership:
    environment.apiUrl + 'membership/v1/create_bulk_membership',
  get_tenant_module_mapping:
    environment.apiUrl + 'ott/v1/get_tenant_module_mapping',
  initiate_payment: environment.apiUrl + 'payment/v1/initiate',
  sync_payment_status: environment.apiUrl + 'payment/v1/sync_status',
};

export const resource_permissions_urls = {
  get_resource_user_roles_feature_permissions:
    environment.apiUrl +
    'resource_permissions/v1/get_resource_user_roles_feature_permissions',
};

export const sublicense_management_urls = {
  get_user_profile_data: environment.apiUrl + 'ott/v1/user-profile',
  get_sublicensee_roles_config:
    environment.apiUrl + 'ott/v1/get_sublicensee_roles_config',
};

export const rnr_end_points = {
  ranking_standing_replica:
    environment.apiUrl + 'ott/v1/rankings/standings_replica/from-snapshot',
  last_published_date:
    environment.apiUrl + 'ott/v1/rankings/standings_replica/last_published',
  combined_standings: environment.apiUrl + 'ott/v1/combined-standings/from-history',
};

/** Match Call Out: the admin's `callout/v1` API for signed-in users, its public `ott/v1` copy for guests. */
export const callout_urls = {
  scheduling_method: environment.apiUrl + 'callout/v1/scheduling_method',
  matches: environment.apiUrl + 'callout/v1/matches',
  public_scheduling_method: environment.apiUrl + 'ott/v1/scheduling_method',
  public_matches: environment.apiUrl + 'ott/v1/callout/matches',
};

export const footer_urls = {
  get_footer_data: environment.apiUrl + 'ott/v1/footer/config/{tenant_code}',
};
